import type {
  UsersSortBy,
  UserStatusValue,
} from 'src/apis/organisation-service/types';
import { labelsToOptions } from 'src/utils/labels-to-options';

export const userStatusLabels: Record<UserStatusValue, string> = {
  INVITED: 'Invited',
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
  INVITATION_EXPIRED: 'Invitation Expired',
};

export const usersSortByValues = [
  'FIRST_NAME',
  'LAST_NAME',
  'EMAIL',
  'STATUS',
] as const satisfies readonly UsersSortBy[];

export const userStatus = [
  'INVITED',
  'ACTIVE',
  'DEACTIVATED',
  'INVITATION_EXPIRED',
] as const satisfies readonly UserStatusValue[];

const userStatusFilterLabels: Record<UserStatusValue, string> = {
  INVITED: 'Invited',
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
  INVITATION_EXPIRED: 'Invitation Expired',
};

export const userStatusOptions = labelsToOptions(userStatusFilterLabels);
